/* unplugin-vue-components disabled */import { render } from "./top-horizontal-menu.vue?vue&type=template&id=313ce74f"
import script from "./top-horizontal-menu.ts?vue&type=script&lang=js"
export * from "./top-horizontal-menu.ts?vue&type=script&lang=js"

import "./top-horizontal-menu.vue?vue&type=style&index=0&id=313ce74f&lang=scss"
import "./top-horizontal-menu.vue?vue&type=style&index=1&id=313ce74f&lang=css"

import exportComponent from "D:\\FIS\\KhanhHoa\\Source_v2\\SourceCode\\GIS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__